import { createContext } from "react";

const FGRefreshContext = createContext(() => {});

export default FGRefreshContext;
